import React, { useState } from "react";
import SyntaxHighlighter from "react-syntax-highlighter";
import styles from "./styles.module.css";
import {
  FaArrowCircleLeft,
  FaArrowCircleRight,
  FaArrowRight,
} from "react-icons/fa";
import { NavLink } from "react-router-dom";
import { data } from "./data";

const Home = (props) => {
  const { isMobile } = props;
  const [isHover, setIsHover] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [tldr, setTldr] = useState(false);

  const chartTypes = ['bar','line','pie']

  const renderFooterRow = () => {
    return (
      <div
        className={styles.footerRow}
        style={{ backgroundColor: isHover && "black" }}
      >
        <div
          onClick={() =>
            setCurrentIndex(
              currentIndex === 0 ? data.length - 1 : currentIndex - 1
            )
          }
          className={styles.button}
        >
          <FaArrowCircleLeft />
        </div>
        <NavLink className={styles.footerText} to="/gallery">
          Visit Gallery
        </NavLink>
        <div
          onClick={() =>
            setCurrentIndex(
              currentIndex === data.length - 1 ? 0 : currentIndex + 1
            )
          }
          className={styles.button}
        >
          <FaArrowCircleRight />
        </div>
      </div>
    );
  };
  const renderCodePreviewer = () => {
    return (
      <div
        onMouseEnter={() => {
          setIsHover(true);
        }}
        onMouseLeave={() => {
          setIsHover(false);
        }}
        className={styles.boxContainer}
        style={{ borderColor: isHover && "black" }}
      >
        <div
          className={styles.boxBody}
          style={{ borderColor: isHover && "black" }}
        >
          <div style={{ display: "flex", width: 700, height: 500 }}>
            <div style={{ alignSelf: "center" }}>
              <img
                src={data[currentIndex].imgSrc}
                style={{ height: 260, borderRadius: 6, cursor:'pointer' }}
                alt=""
                onClick={()=>{window.location.pathname=`/gallery${chartTypes[currentIndex]}`}}
              />
            </div>

            <SyntaxHighlighter language="javascript">
              {data[currentIndex].code}
            </SyntaxHighlighter>
          </div>
        </div>
        {renderFooterRow()}
      </div>
    );
  };
  const renderBody = () => {
    return (
      <div className={styles.bodyText}>
        <p>
          Build awesome charts in <b>React Native</b>
        </p>
        <h1>TL;DR</h1>
        <p style={{ color: "navy", fontSize: 20 }}>
          Jump straight to examples <FaArrowRight />
        </p>
        <div>
          {"Detailed documentation and step-by-step guide "}
          <NavLink className={styles.linkText} to="/barchart">
            here
          </NavLink>
        </div>
      </div>
    );
  };

  const renderMobileBody = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: 10,
        }}
      >
        <p>
          Build awesome charts in <b>React Native</b>
        </p>
        <h1>TL;DR</h1>
        <p
          onClick={() => setTldr(true)}
          style={{ color: "navy", fontSize: 20 }}
        >
          Jump straight to examples
        </p>
        <div>
          {"Detailed documentation and step-by-step guide "}
          <NavLink className={styles.linkText} to="/barchart">
            here
          </NavLink>
        </div>
        <img
          src={require("../../assets/all.png")}
          className={styles.allImage}
          alt=""
        />
      </div>
    );
  };

  const renderCodePreviewerMobile = () => {
    return (
      <div>
        <div
          onClick={() => setTldr(false)}
          style={{
            color: "navy",
            fontSize: 24,
            fontWeight: "bold",
            margin: 10,
          }}
        >
          <FaArrowCircleLeft />
        </div>
        <img
          src={data[0].imgSrc}
          style={{ height: 260, width: 260, borderRadius: 6, marginLeft: 10 }}
          alt=""
          onClick={()=>{window.location.pathname="/gallerybar"}}
        />

        <SyntaxHighlighter language="javascript">
          {data[0].code}
        </SyntaxHighlighter>

        <hr />
        <br />
        <br />

        <img
          src={data[1].imgSrc}
          style={{ height: 260, width: 260, borderRadius: 6, marginLeft: 10 }}
          alt=""
          onClick={()=>{window.location.pathname="/galleryline"}}
        />

        <SyntaxHighlighter language="javascript">
          {data[1].code}
        </SyntaxHighlighter>

        <hr />
        <br />
        <br />

        <img
          src={data[2].imgSrc}
          style={{ height: 260, width: 300, borderRadius: 6, marginLeft: 10 }}
          alt=""
          onClick={()=>{window.location.pathname="/gallerypie"}}
        />

        <SyntaxHighlighter language="javascript">
          {data[2].code}
        </SyntaxHighlighter>

        <hr />
        <br />

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 100,
          }}
        >
          <div
            onClick={() => setTldr(true)}
            style={{ color: "navy", fontSize: 18, fontWeight: "bold" }}
          >
            <NavLink to="/gallery">Visit Gallery for more</NavLink>
          </div>
          <div style={{ margin: 20 }}>OR</div>
          <div
            onClick={() => setTldr(false)}
            style={{ color: "navy", fontSize: 18, fontWeight: "bold" }}
          >
            Back to Home
          </div>
        </div>
      </div>
    );
  };

  const mobileView = () => {
    return tldr ? renderCodePreviewerMobile() : renderMobileBody();
  };

  // const chandrayaan = () => {
  //   return (
  //     <>
  //       <img
  //         src="https://user-images.githubusercontent.com/20596944/262664878-896eed43-ebc4-4983-9f69-3a52463a1258.png"
  //         style={
  //           width > 850
  //             ? {
  //                 position: "absolute",
  //                 height: 120,
  //                 width: 460,
  //                 paddingLeft: 40,
  //                 paddingTop: 40,
  //               }
  //             : null
  //         }
  //         alt="chandrayaan-3"
  //       />
  //       <div
  //         style={
  //           width > 850?
  //           {
  //           paddingLeft: 16,
  //           paddingTop: 16,
  //           top: width > 850 ? 260 : 0,
  //           position: 'absolute',
  //         }
  //         :
  //         {
  //           padding:6,
  //           fontSize:12
  //         }
  //       }
  //       >
  //         <div>This is a proud moment for India and the world.</div>
  //         <div>
  //           Chandrayaan 3 has landed safely on the South pole of the moon,
  //         </div>
  //         <div>
  //           making India the first country to land on the lunar south pole!
  //         </div>
  //       </div>
  //     </>
  //   );
  // };

  return (
    <div className={isMobile ? styles.container : styles.containerMobile}>
      {!isMobile ? (
        <div className={styles.row}>
          {renderBody()}
          {renderCodePreviewer()}
        </div>
      ) : (
        mobileView()
      )}
    </div>
  );
};

export default Home;
